import { Companion_getInstance1a3oieudzv4l4 as Companion_getInstance } from './PrimitiveRanges.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import { Companion_instance2r6wsk1n1bbyk as Companion_instance } from './Progressions.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import {
  checkStepIsPositive70940ky00dt4 as checkStepIsPositive,
  ClosedFloatingPointRange3bek8kkkwkj9x as ClosedFloatingPointRange,
} from './Ranges.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function until(_this__u8e3s4, to) {
  if (to <= -2147483648)
    return Companion_getInstance().g2_1;
  return numberRangeToNumber(_this__u8e3s4, to - 1 | 0);
}
function downTo(_this__u8e3s4, to) {
  return Companion_instance.h2(_this__u8e3s4, to, -1);
}
function coerceIn(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue > maximumValue)
    throw IllegalArgumentException().a1('Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
  if (_this__u8e3s4 < minimumValue)
    return minimumValue;
  if (_this__u8e3s4 > maximumValue)
    return maximumValue;
  return _this__u8e3s4;
}
function coerceIn_0(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue > maximumValue)
    throw IllegalArgumentException().a1('Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
  if (_this__u8e3s4 < minimumValue)
    return minimumValue;
  if (_this__u8e3s4 > maximumValue)
    return maximumValue;
  return _this__u8e3s4;
}
function coerceAtMost(_this__u8e3s4, maximumValue) {
  return compareTo(_this__u8e3s4, maximumValue) > 0 ? maximumValue : _this__u8e3s4;
}
function coerceAtLeast(_this__u8e3s4, minimumValue) {
  return compareTo(_this__u8e3s4, minimumValue) < 0 ? minimumValue : _this__u8e3s4;
}
function coerceIn_1(_this__u8e3s4, minimumValue, maximumValue) {
  if (minimumValue > maximumValue)
    throw IllegalArgumentException().a1('Cannot coerce value to an empty range: maximum ' + maximumValue.toString() + ' is less than minimum ' + minimumValue.toString() + '.');
  if (_this__u8e3s4 < minimumValue)
    return minimumValue;
  if (_this__u8e3s4 > maximumValue)
    return maximumValue;
  return _this__u8e3s4;
}
function coerceAtLeast_0(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function coerceAtMost_0(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function step(_this__u8e3s4, step) {
  checkStepIsPositive(step > 0, step);
  return Companion_instance.h2(_this__u8e3s4.i2_1, _this__u8e3s4.j2_1, _this__u8e3s4.k2_1 > 0 ? step : -step | 0);
}
function coerceAtMost_1(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function coerceIn_2(_this__u8e3s4, range) {
  if (isInterface(range, ClosedFloatingPointRange())) {
    return coerceIn_4(_this__u8e3s4, range);
  }
  if (range.i1())
    throw IllegalArgumentException().a1('Cannot coerce value to an empty range: ' + toString(range) + '.');
  return compareTo(_this__u8e3s4, range.j1()) < 0 ? range.j1() : compareTo(_this__u8e3s4, range.k1()) > 0 ? range.k1() : _this__u8e3s4;
}
function coerceAtLeast_1(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function coerceAtMost_2(_this__u8e3s4, maximumValue) {
  return _this__u8e3s4 > maximumValue ? maximumValue : _this__u8e3s4;
}
function coerceIn_3(_this__u8e3s4, range) {
  if (isInterface(range, ClosedFloatingPointRange())) {
    return coerceIn_4(_this__u8e3s4, range);
  }
  if (range.i1())
    throw IllegalArgumentException().a1('Cannot coerce value to an empty range: ' + toString(range) + '.');
  return _this__u8e3s4 < range.j1() ? range.j1() : _this__u8e3s4 > range.k1() ? range.k1() : _this__u8e3s4;
}
function contains(_this__u8e3s4, value) {
  // Inline function 'kotlin.let' call
  var it = toIntExactOrNull(value);
  return !(it == null) ? _this__u8e3s4.l2(it) : false;
}
function coerceIn_4(_this__u8e3s4, range) {
  if (range.i1())
    throw IllegalArgumentException().a1('Cannot coerce value to an empty range: ' + toString(range) + '.');
  return range.m2(_this__u8e3s4, range.j1()) && !range.m2(range.j1(), _this__u8e3s4) ? range.j1() : range.m2(range.k1(), _this__u8e3s4) && !range.m2(_this__u8e3s4, range.k1()) ? range.k1() : _this__u8e3s4;
}
function toIntExactOrNull(_this__u8e3s4) {
  return (-2147483648n <= _this__u8e3s4 ? _this__u8e3s4 <= 2147483647n : false) ? convertToInt(_this__u8e3s4) : null;
}
function coerceAtLeast_2(_this__u8e3s4, minimumValue) {
  return _this__u8e3s4 < minimumValue ? minimumValue : _this__u8e3s4;
}
function coerceIn_5(_this__u8e3s4, range) {
  if (isInterface(range, ClosedFloatingPointRange())) {
    return coerceIn_4(_this__u8e3s4, range);
  }
  if (range.i1())
    throw IllegalArgumentException().a1('Cannot coerce value to an empty range: ' + toString(range) + '.');
  return _this__u8e3s4 < range.j1() ? range.j1() : _this__u8e3s4 > range.k1() ? range.k1() : _this__u8e3s4;
}
//region block: exports
export {
  coerceAtLeast_2 as coerceAtLeastklytehohcpeq,
  coerceAtLeast as coerceAtLeast3jlgfquiyquc9,
  coerceAtLeast_0 as coerceAtLeast2bkz8m9ik7hep,
  coerceAtLeast_1 as coerceAtLeast1b3m6f7g22ivr,
  coerceAtMost_1 as coerceAtMostfyc3emgaderp,
  coerceAtMost as coerceAtMost31oazapy1u82u,
  coerceAtMost_2 as coerceAtMost1wyvl5p1shiw0,
  coerceAtMost_0 as coerceAtMost322komnqp70ag,
  coerceIn_0 as coerceIn1xblvmyr0tby6,
  coerceIn as coerceIn10f36k81le1mm,
  coerceIn_1 as coerceIn302bduskdb54x,
  coerceIn_2 as coerceIn82duc7igyjd0,
  coerceIn_3 as coerceIn1fn1ki3gdsgfi,
  coerceIn_5 as coerceIn10fbf4zn2whhq,
  contains as contains2c50nlxg7en7o,
  downTo as downTo39qhfeycepm1j,
  step as step18s9qzr5xwxat,
  until as until1jbpn0z3f8lbg,
};
//endregion

//# sourceMappingURL=_Ranges.mjs.map
